<template>
    <div class="w-100 advanced-search topic-explorer pb-5 mb-5">
        <h2 class="vx-col w-full" style="text-align: center; margin: 0 0 20px 0">Topic Explorer</h2>

        <vx-card>
            <div class="vx-row gutter-half mb-5">
                <div class="vx-col w-full">
                    <vx-input-group class="custom-input-group">
                        <div class="text-center pb-2">
                            <b>Year: </b>
                        </div>
                        <div class="d-flex justify-center mb-5 pb-5">
                            <div class="vx-input-group-append flex-grow">
                                <div class="append-text btn-addon">
                                    <vs-button
                                        color="primary"
                                        type="border"
                                        v-for="(v, i) in 12"
                                        :key="i"
                                        @click="toggleYearLevel(v)"
                                        class="radiobtn"
                                        :class="{selected: filters.grade_in.indexOf(v) !== -1}">
                                        {{v}}
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </vx-input-group>
                </div>
            </div>
            <div class="vx-row gutter-half mb-5">
                <div class="vx-col w-full sm:w-full md:w-1/5">
                    <div class="text-center pb-2"><b>Subject: </b></div>
                    <div class="d-flex align-center">
                        <v-select name="subject"
                                  class="flex-grow custom-width left"
                                  placeholder="Select Subject"
                                  :options="subjects"
                                  :searchable="false"
                                  @input="getUnits"
                                  v-model="filters.subject">
                            <template #list-header>
                                <li style="text-align: center" v-if="!subjects.length">Loading Subjects...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>

                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/5" :class="{'filter-disabled': !units.length}">
                    <div class="text-center pb-2"><b>Unit: </b></div>
                    <div class="d-flex align-center" >
                        <v-select name="subject"
                                  class="flex-grow custom-width left"
                                  placeholder="Select Unit"
                                  :options="units"
                                  :disabled="!units.length"
                                  @input="getChapters"
                                  v-model="filters.unit">
                            <template #list-header>
                                <li style="text-align: center" v-if="!units.length">Loading Units...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>

                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/5" :class="{'filter-disabled': !chapters.length}">
                    <div class="text-center pb-2"><b>Chapter: </b></div>
                    <div class="d-flex align-center" >
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Chapter "
                                  :options="chapters"
                                  :disabled="!chapters.length"
                                  @input="getTopics"
                                  v-model="filters.chapter">
                            <template #list-header>
                                <li style="text-align: center" v-if="!chapters.length">Loading Chapters...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>

                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/5" :class="{'filter-disabled': !topics.length}">
                    <div class="text-center pb-2"><b>Topic: </b></div>
                    <div class="d-flex align-center">
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Topic"
                                  :options="topics"
                                  :disabled="!topics.length"
                                  @input="getTitles"
                                  v-model="filters.topic">
                            <template #list-header>
                                <li style="text-align: center" v-if="!topics.length">Loading Topics...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-full md:w-1/5" :class="{'filter-disabled': !titles.length}">
                    <div class="text-center pb-2"><b>Concept: </b></div>
                    <div class="d-flex align-center">
                        <v-select name="subject"
                                  class="flex-grow custom-width right"
                                  placeholder="Select Concept"
                                  :options="titles"
                                  :disabled="!titles.length"
                                  v-model="filters.title">
                            <template #list-header>
                                <li style="text-align: center" v-if="!titles.length">Loading Concepts...</li>
                            </template>
                            <template #no-options="{ search, searching, loading }">
                                <span></span>
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>
        </vx-card>
        <div class="pagination-block mb-5">
            <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="mt-base" v-if="totalPages > 1"
                           @change="handlePaginationChange"></vs-pagination>
        </div>
        <div class="vx-row">
            <div class="vx-col custom-asset-card mb-base w-1/2 sm:w-1/3 lg:w-1/5"
                 v-for="(item, index) in items" :key="index">
                <AssetItem :item="item" :show-images="showImages"/>
            </div>
        </div>
        <div class="pagination-block mb-5">
            <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="mt-base" v-if="totalPages > 1"
                           @change="handlePaginationChange"></vs-pagination>
        </div>
    </div>
</template>

<script>

    import axios from "axios";
    import vSelect from 'vue-select'
    import AssetItem from "../components/AssetItem";

    export default {
        name: "AdvSearch",
        components: {vSelect, AssetItem},
        props: {},
        data() {
            return {
                filters: {
                    subject: "",
                    unit: "",
                    chapter: "",
                    topic: "",
                    title: "",
                    grade_in: [],
                    order_by: "updatedAt",
                    order: "desc",
                },
                subjects: [],
                units: [],
                chapters: [],
                topics: [],
                titles: [],
                types: this.$store.state.types,
                items: [],
                currentPage: 1,
                totalItems: 0,
                itemsPerPage: 15,
                totalPages: 0,
                showImages: true,
                isLoading: false,
            }
        },
        computed: {
            componentName: () => {
                return "AdvancedSearch"
            },
            filtersObj() {
                return {
                    grade_in: JSON.stringify(this.filters.grade_in.map(g => g.toString())),
                    subject: this.filters.subject,
                    unit: this.filters.unit,
                    chapter: this.filters.chapter,
                    topic: this.filters.topic,
                    title: this.filters.title,
                    _start: (this.currentPage - 1) * this.itemsPerPage,
                    _limit: this.itemsPerPage,
                    order_by: this.filters.order_by,
                    order: this.filters.order,
                }
            },
            filtersQuery() {
                return Object.keys(this.filtersObj).filter(k => Boolean(this.filtersObj[k]) || this.filtersObj[k] === 0).map(k => `${k}=${this.filtersObj[k]}`).join("&")
            }
        },
        mounted() {
            this.getSubjects();
            this.fetchItems();
        },
        watch: {
            filtersObj(next, prev) {
                if (!compareObjects(next, prev)) {
                    this.fetchItems()
                }
            }
        },
        methods: {
            toggleYearLevel(g) {
                let ind = this.filters.grade_in.indexOf(g);
                if (ind === -1) {
                    this.filters.grade_in.push(g)
                } else {
                    this.filters.grade_in.splice(ind, 1)
                }
                this.gradeOnChange();
            },
            clear(fieldName) {
              const  map = ['subjects', 'units', 'chapters', 'topics', 'titles'].reverse();
              const clearMap = {
                  subjects: () => {this.subjects = []; this.filters.subject = ''},
                  units: () => {this.units = []; this.filters.unit = ''},
                  chapters: () => {this.chapters = []; this.filters.chapter = ''},
                  topics: () => {this.topics = []; this.filters.topic = ''},
                  titles: () => {this.titles = []; this.filters.title = ''},
              }
              let ind = map.indexOf(fieldName);
              if (ind < 0) return;
              for (let i=0; i<=ind; i++) {
                  clearMap[map[i]]();
              }
            },
            gradeOnChange() {
                    clearTimeout(this.gradeTimeout);
                    this.gradeTimeout = setTimeout(()=> {
                        this.filters.subject = ""
                        this.getSubjects();
                    }, 1000)
            },
            getSubjects() {
                this.clear("subjects");
                let url = `/subject-list?${this.filtersQuery}`;
                this.$axios.get(url).then(res => {
                    this.subjects = res.data;
                }).catch(e => {
                    console.log(url, e.message)
                })
            },
            getUnits() {
                this.clear("units")
                let url = `/units-list?${this.filtersQuery}`;
                this.$axios.get(url).then(res => {
                    this.units = res.data;
                }).catch(e => {
                    console.log(url, e.message)
                })
            },
            getChapters() {
                this.clear("chapters")
                let url = `/chapters-list?${this.filtersQuery}`;
                this.$axios.get(url).then(res => {
                    this.chapters = res.data;
                }).catch(e => {
                    console.log(url, e.message)
                })
            },
            getTopics() {
                this.clear("topics")
                let url = `/topics-list?${this.filtersQuery}`;
                this.$axios.get(url).then(res => {
                    this.topics = res.data;
                }).catch(e => {
                    console.log(url, e.message)
                })
            },
            getTitles() {
                this.clear('titles')
                let url = `/titles-list?${this.filtersQuery}`;
                this.$axios.get(url).then(res => {
                    this.titles = res.data;
                }).catch(e => {
                    console.log(url, e.message)
                })
            },
            clearSearch() {
                this.isLoading = false;
                if (this.cancelSearchToken && this.cancelSearchToken.cancel) {
                    this.cancelSearchToken.cancel({err: "Operation canceled by user action."});
                }
            },
            handlePaginationChange() {
                this.fetchItems();
            },
            fetchItems() {
                this.isLoading = true;
                clearTimeout(this.fetchDebounce);
                this.fetchDebounce = setTimeout(() => {
                    // this.items = [];
                    if (this.cancelSearchToken && this.cancelSearchToken.cancel) {
                        this.cancelSearchToken.cancel({err: "Operation canceled by new search.", newSearch: true});
                    }
                    this.conceptsLoading = true;
                    this.cancelSearchToken = axios.CancelToken.source();
                    this.$axios.get(`/assets/adv-search?${this.filtersQuery}`, {cancelToken: this.cancelSearchToken.token}).then(res => {
                        if (res.data && res.data.items) {
                            this.items = res.data.items;
                        }
                        this.totalItems = res.data.total;
                        this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
                        this.isLoading = false;
                        this.cancelSearchToken = null;
                    }).catch(e => {
                        console.log('catch_search', e)
                        this.items = [];
                        this.isLoading = Boolean(e.message.newSearch);
                        this.cancelSearchToken = null;
                    })
                }, 500)
            },
        },
    }
    function compareObjects(object1, object2) {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (let key of keys1) {
            if (object1[key] !== object2[key]) {
                return false;
            }
        }

        return true;
    }
</script>
